// // export default function ContactForm() {
// //     return (
// //       <section className="py-20 px-4 bg-secondary-900">
// //         <div className="max-w-3xl mx-auto">
// //           <h2 className="text-3xl md:text-4xl font-heading font-bold text-center mb-12 text-primary-100">
// //             Get in Touch
// //           </h2>
          
// //           <form className="space-y-6">
// //             <div>
// //               <label className="block text-primary-200 mb-2">Name</label>
// //               <input
// //                 type="text"
// //                 className="w-full p-3 bg-secondary-800 border border-secondary-700 rounded-lg text-primary-100 focus:ring-2 focus:ring-accent-500 focus:border-transparent"
// //               />
// //             </div>
            
// //             <div>
// //               <label className="block text-primary-200 mb-2">Email</label>
// //               <input
// //                 type="email"
// //                 className="w-full p-3 bg-secondary-800 border border-secondary-700 rounded-lg text-primary-100 focus:ring-2 focus:ring-accent-500 focus:border-transparent"
// //               />
// //             </div>
            
// //             <div>
// //               <label className="block text-primary-200 mb-2">Message</label>
// //               <textarea
// //                 rows="4"
// //                 className="w-full p-3 bg-secondary-800 border border-secondary-700 rounded-lg text-primary-100 focus:ring-2 focus:ring-accent-500 focus:border-transparent"
// //               ></textarea>
// //             </div>
            
// //             <button
// //               type="submit"
// //               className="w-full bg-accent-500 text-primary-900 py-3 px-6 rounded-lg font-semibold hover:bg-accent-600 transition-colors"
// //             >
// //               Send Message
// //             </button>
// //           </form>
// //         </div>
// //       </section>
// //     )
// //   }

// // export default function ContactForm() {
// //     return (
// //       <section className="py-20 px-4 bg-primary-900">
// //         <div className="max-w-3xl mx-auto">
// //           <h2 className="text-3xl md:text-4xl font-heading font-bold text-center mb-12 text-primary-50">
// //             Request a Quote
// //           </h2>
          
// //           <form className="space-y-6">
// //             <div>
// //               <label className="block text-primary-200 mb-2">Name</label>
// //               <input
// //                 type="text"
// //                 className="w-full p-3 bg-primary-800 border border-primary-700 rounded-lg text-primary-50 focus:ring-2 focus:ring-accent-500 focus:border-transparent"
// //               />
// //             </div>
            
// //             <div>
// //               <label className="block text-primary-200 mb-2">Email</label>
// //               <input
// //                 type="email"
// //                 className="w-full p-3 bg-primary-800 border border-primary-700 rounded-lg text-primary-50 focus:ring-2 focus:ring-accent-500 focus:border-transparent"
// //               />
// //             </div>
            
// //             <div>
// //               <label className="block text-primary-200 mb-2">Project Details</label>
// //               <textarea
// //                 rows="4"
// //                 className="w-full p-3 bg-primary-800 border border-primary-700 rounded-lg text-primary-50 focus:ring-2 focus:ring-accent-500 focus:border-transparent"
// //               ></textarea>
// //             </div>
            
// //             <button
// //               type="submit"
// //               className="w-full bg-accent-500 text-primary-900 py-3 px-6 rounded-lg font-semibold hover:bg-accent-600 transition-colors"
// //             >
// //               Submit Inquiry
// //             </button>
// //           </form>
// //         </div>
// //       </section>
// //     )
// //   }
// import { useState } from 'react';

// import { MapPinIcon, PhoneIcon, EnvelopeIcon, ClockIcon } from '@heroicons/react/24/outline'

// export default function ContactSection() {
//   const [formData, setFormData] = useState({
//     name: '',
//     email: '',
//     service: '',
//     message: ''
//   })

//   const [submitted, setSubmitted] = useState(false)

//   const services = [
//     'Offset Printing',
//     'Digital Printing',
//     'Pre-Press Services',
//     'Post-Press Finishing',
//     'Packaging Solutions'
//   ]

//   return (
//     <section className="relative py-20 px-4 bg-neutral-light">
//       <div className="max-w-7xl mx-auto">
//         {/* Section Header */}
//         <div className="text-center mb-16">
//           <h2 className="text-4xl md:text-5xl font-heading text-primary-dark mb-4">
//             Get in Touch
//           </h2>
//           <p className="text-secondary-base max-w-2xl mx-auto text-lg">
//             Let's create something remarkable together. Reach out for inquiries, quotes, 
//             or to discuss your next printing project.
//           </p>
//         </div>

//         <div className="grid md:grid-cols-2 gap-12 lg:gap-20">
//           {/* Contact Form */}
//           <div className="bg-white p-8 rounded-2xl shadow-xl">
//             {submitted ? (
//               <div className="text-center p-12">
//                 <div className="text-accent-base text-6xl mb-6">✓</div>
//                 <h3 className="text-2xl font-heading text-primary-dark mb-4">
//                   Message Received!
//                 </h3>
//                 <p className="text-secondary-base">
//                   We'll respond within 24 hours. Thank you for contacting us.
//                 </p>
//               </div>
//             ) : (
//               <form className="space-y-6">
//                 <div>
//                   <label className="block text-sm font-semibold text-primary-dark mb-2">
//                     Full Name
//                   </label>
//                   <input
//                     type="text"
//                     className="w-full px-4 py-3 border border-neutral-dark/20 rounded-lg
//                       focus:ring-2 focus:ring-accent-base focus:border-transparent"
//                     placeholder="John Doe"
//                   />
//                 </div>

//                 <div>
//                   <label className="block text-sm font-semibold text-primary-dark mb-2">
//                     Email Address
//                   </label>
//                   <input
//                     type="email"
//                     className="w-full px-4 py-3 border border-neutral-dark/20 rounded-lg
//                       focus:ring-2 focus:ring-accent-base focus:border-transparent"
//                     placeholder="john@company.com"
//                   />
//                 </div>

//                 <div>
//                   <label className="block text-sm font-semibold text-primary-dark mb-2">
//                     Service Needed
//                   </label>
//                   <select
//                     className="w-full px-4 py-3 border border-neutral-dark/20 rounded-lg
//                       focus:ring-2 focus:ring-accent-base focus:border-transparent"
//                   >
//                     <option value="">Select a service</option>
//                     {services.map((service, index) => (
//                       <option key={index} value={service}>{service}</option>
//                     ))}
//                   </select>
//                 </div>

//                 <div>
//                   <label className="block text-sm font-semibold text-primary-dark mb-2">
//                     Project Details
//                   </label>
//                   <textarea
//                     rows="4"
//                     className="w-full px-4 py-3 border border-neutral-dark/20 rounded-lg
//                       focus:ring-2 focus:ring-accent-base focus:border-transparent"
//                     placeholder="Tell us about your project..."
//                   ></textarea>
//                 </div>

//                 <button
//                   type="submit"
//                   className="w-full bg-accent-base text-primary-dark py-4 px-6 rounded-lg
//                     font-semibold hover:bg-accent-light transition-colors shadow-md
//                     hover:shadow-lg"
//                 >
//                   Send Message
//                 </button>
//               </form>
//             )}
//           </div>

//           {/* Contact Info */}
//           <div className="space-y-8">
//             <div className="bg-primary-dark text-neutral-light p-8 rounded-2xl shadow-xl">
//               <h3 className="text-2xl font-heading mb-6">Visit Us</h3>
              
//               <div className="space-y-6">
//                 <div className="flex items-start gap-4">
//                   <MapPinIcon className="h-6 w-6 text-accent-base flex-shrink-0" />
//                   <div>
//                     <p className="font-semibold">Capital Offset Printing Press</p>
//                     <p>123 Industrial Estate</p>
//                     <p>Ahmedabad, Gujarat 380001</p>
//                   </div>
//                 </div>

//                 <div className="flex items-center gap-4">
//                   <PhoneIcon className="h-6 w-6 text-accent-base" />
//                   <div>
//                     <p className="font-semibold">+91 12345 67890</p>
//                     <p>Mon-Sat: 9AM - 7PM</p>
//                   </div>
//                 </div>

//                 <div className="flex items-center gap-4">
//                   <EnvelopeIcon className="h-6 w-6 text-accent-base" />
//                   <p className="font-semibold">contact@satyamprinting.com</p>
//                 </div>
//               </div>
//             </div>

//             {/* Office Hours */}
//             <div className="bg-white p-8 rounded-2xl shadow-xl">
//               <div className="flex items-center gap-4 mb-6">
//                 <ClockIcon className="h-8 w-8 text-primary-dark" />
//                 <h3 className="text-xl font-heading text-primary-dark">
//                   Working Hours
//                 </h3>
//               </div>
//               <dl className="space-y-4">
//                 <div className="flex justify-between">
//                   <dt className="text-secondary-base">Monday - Friday</dt>
//                   <dd className="font-semibold text-primary-dark">9AM - 7PM</dd>
//                 </div>
//                 <div className="flex justify-between">
//                   <dt className="text-secondary-base">Saturday</dt>
//                   <dd className="font-semibold text-primary-dark">10AM - 5PM</dd>
//                 </div>
//                 <div className="flex justify-between">
//                   <dt className="text-secondary-base">Sunday</dt>
//                   <dd className="font-semibold text-primary-dark">Closed</dd>
//                 </div>
//               </dl>
//             </div>
//           </div>
//         </div>

//         {/* Decorative Elements */}
//         <div className="absolute top-0 right-0 w-48 h-48 bg-accent-base/10 rounded-full 
//           -translate-y-1/2 translate-x-1/2" />
//         <div className="absolute bottom-0 left-0 w-32 h-32 bg-primary-dark/10 rounded-full 
//           translate-y-1/2 -translate-x-1/2" />
//       </div>
//     </section>
//   )
// }

// import { useState } from 'react';
// import emailjs from 'emailjs-com';  // Import EmailJS

// import { MapPinIcon, PhoneIcon, EnvelopeIcon, ClockIcon } from '@heroicons/react/24/outline'

// export default function ContactSection() {
//   const [formData, setFormData] = useState({
//     name: '',
//     email: '',
//     service: '',
//     message: ''
//   })

//   const [submitted, setSubmitted] = useState(false)

//   const services = [
//     'Offset Printing',
//     'Digital Printing',
//     'Pre-Press Services',
//     'Post-Press Finishing',
//     'Packaging Solutions'
//   ]

//   // Handle form submission
//   const handleSubmit = (e) => {
//     e.preventDefault();
    
//     // EmailJS configuration
//     emailjs.sendForm(
//       'service_ak2p4qx', // EmailJS service ID
//       'template_x5vcbli', // EmailJS template ID
//       e.target, // Form elements
//       'A_dsBSa_EcN9tjqag' // EmailJS user ID
//     )
//     .then(
//       (result) => {
//         console.log(result.text); // Log success message
//         setSubmitted(true); // Show submission success
//       },
//       (error) => {
//         console.log(error.text); // Log error if any
//       }
//     );
//   }

//   return (
//     <section className="relative py-20 px-4 bg-neutral-light">
//       <div className="max-w-7xl mx-auto">
//         {/* Section Header */}
//         <div className="text-center mb-16">
//           <h2 className="text-4xl md:text-5xl font-heading text-primary-dark mb-4">
//             Get in Touch
//           </h2>
//           <p className="text-secondary-base max-w-2xl mx-auto text-lg">
//             Let's create something remarkable together. Reach out for inquiries, quotes, 
//             or to discuss your next printing project.
//           </p>
//         </div>

//         <div className="grid md:grid-cols-2 gap-12 lg:gap-20">
//           {/* Contact Form */}
//           <div className="bg-white p-8 rounded-2xl shadow-xl">
//             {submitted ? (
//               <div className="text-center p-12">
//                 <div className="text-accent-base text-6xl mb-6">✓</div>
//                 <h3 className="text-2xl font-heading text-primary-dark mb-4">
//                   Message Received!
//                 </h3>
//                 <p className="text-secondary-base">
//                   We'll respond soon, Thank you for contacting us.
//                 </p>
//               </div>
//             ) : (
//               <form onSubmit={handleSubmit} className="space-y-6">
//                 <div>
//                   <label className="block text-sm font-semibold text-primary-dark mb-2">
//                     Full Name
//                   </label>
//                   <input
//                     type="text"
//                     name="name"  // Name attribute to match template variable
//                     className="w-full px-4 py-3 border border-neutral-dark/20 rounded-lg
//                       focus:ring-2 focus:ring-accent-base focus:border-transparent"
//                     placeholder="John Doe"
//                   />
//                 </div>

//                 <div>
//                   <label className="block text-sm font-semibold text-primary-dark mb-2">
//                     Email Address
//                   </label>
//                   <input
//                     type="email"
//                     name="email"  // Name attribute to match template variable
//                     className="w-full px-4 py-3 border border-neutral-dark/20 rounded-lg
//                       focus:ring-2 focus:ring-accent-base focus:border-transparent"
//                     placeholder="john@company.com"
//                   />
//                 </div>

//                 <div>
//                   <label className="block text-sm font-semibold text-primary-dark mb-2">
//                     Service Needed
//                   </label>
//                   <select
//                     name="service"  // Name attribute to match template variable
//                     className="w-full px-4 py-3 border border-neutral-dark/20 rounded-lg
//                       focus:ring-2 focus:ring-accent-base focus:border-transparent"
//                   >
//                     <option value="">Select a service</option>
//                     {services.map((service, index) => (
//                       <option key={index} value={service}>{service}</option>
//                     ))}
//                   </select>
//                 </div>

//                 <div>
//                   <label className="block text-sm font-semibold text-primary-dark mb-2">
//                     Project Details
//                   </label>
//                   <textarea
//                     name="message"  // Name attribute to match template variable
//                     rows="4"
//                     className="w-full px-4 py-3 border border-neutral-dark/20 rounded-lg
//                       focus:ring-2 focus:ring-accent-base focus:border-transparent"
//                     placeholder="Tell us about your project..."
//                   ></textarea>
//                 </div>

//                 <button
//                   type="submit"
//                   className="w-full bg-accent-base text-primary-dark py-4 px-6 rounded-lg
//                     font-semibold hover:bg-accent-light transition-colors shadow-md
//                     hover:shadow-lg"
//                 >
//                   Send Message
//                 </button>
//               </form>
//             )}
//           </div>

//           {/* Contact Info */}
//           <div className="space-y-8">
//             <div className="bg-primary-dark text-neutral-light p-8 rounded-2xl shadow-xl">
//               <h3 className="text-2xl font-heading mb-6">Visit Us</h3>
              
//               <div className="space-y-6">
//                 <div className="flex items-start gap-4">
//                   <MapPinIcon className="h-6 w-6 text-accent-base flex-shrink-0" />
//                   <div>
//                     <p className="font-semibold">Capital Offset Printing Press</p>
//                     <p>603-604, 6th Floor, Haveli Arcade, Sector 11,</p>
//                     <p> Gandhinagar, Gujarat 382011</p>
//                   </div>
//                 </div>

//                 <div className="flex items-center gap-4">
//                   <PhoneIcon className="h-6 w-6 text-accent-base" />
//                   <div>
//                     <p className="font-semibold">096381 83838</p>
//                     <p>Mon-Sat: 9AM - 7PM</p>
//                   </div>
//                 </div>

//                 <div className="flex items-center gap-4">
//                   <EnvelopeIcon className="h-6 w-6 text-accent-base" />
//                   <p className="font-semibold">contact@Capital Offset.in</p>
//                 </div>
//               </div>
//             </div>

//             {/* Office Hours */}
//             <div className="bg-white p-8 rounded-2xl shadow-xl">
//               <div className="flex items-center gap-4 mb-6">
//                 <ClockIcon className="h-8 w-8 text-primary-dark" />
//                 <h3 className="text-xl font-heading text-primary-dark">
//                   Working Hours
//                 </h3>
//               </div>
//               <dl className="space-y-4">
//                 <div className="flex justify-between">
//                   <dt className="text-secondary-base">Monday - Saturday</dt>
//                   <dd className="font-semibold text-primary-dark">9AM - 8PM</dd>
//                 </div>
//                 {/* <div className="flex justify-between">
//                   <dt className="text-secondary-base">Saturday</dt>
//                   <dd className="font-semibold text-primary-dark">10AM - 5PM</dd>
//                 </div> */}
//                 <div className="flex justify-between">
//                   <dt className="text-secondary-base">Sunday</dt>
//                   <dd className="font-semibold text-primary-dark">Closed</dd>
//                 </div>
//               </dl>
//             </div>
//           </div>
//         </div>

//         {/* Decorative Elements */}
//         <div className="absolute top-0 right-0 w-48 h-48 bg-accent-base/10 rounded-full 
//           -translate-y-1/2 translate-x-1/2" />
//         <div className="absolute bottom-0 left-0 w-32 h-32 bg-primary-dark/10 rounded-full 
//           translate-y-1/2 -translate-x-1/2" />
//       </div>
//     </section>
//   )
// }

import { useState } from 'react';
import emailjs from 'emailjs-com';  // Import EmailJS

import { MapPinIcon, PhoneIcon, EnvelopeIcon, ClockIcon } from '@heroicons/react/24/outline'

export default function ContactSection() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    service: '',
    message: ''
  })

  const [submitted, setSubmitted] = useState(false)
  const [loading, setLoading] = useState(false) // Loading state

  const services = [
    'Offset Printing',
    'Digital Printing',
    'Pre-Press Services',
    'Post-Press Finishing',
    'Packaging Solutions'
  ]

  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true); // Set loading to true when form is being submitted

    // EmailJS configuration
    emailjs.sendForm(
      'service_s4gehvp', // EmailJS service ID
      'template_mobfywh', // EmailJS template ID
      e.target, // Form elements
      '0dGViV-aKMedLDEiL' // EmailJS user ID
    )
    .then(
      (result) => {
        console.log(result.text); // Log success message
        setSubmitted(true); // Show submission success
        setLoading(false); // Reset loading state
      },
      (error) => {
        console.log(error.text); // Log error if any
        setLoading(false); // Reset loading state even in case of error
      }
    );
  }

  return (
    <section className="relative py-20 px-4 bg-neutral-light">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-heading text-primary-dark mb-4">
            Get in Touch
          </h2>
          <p className="text-secondary-base max-w-2xl mx-auto text-lg">
            Let's create something remarkable together. Reach out for inquiries, quotes, 
            or to discuss your next printing project.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-12 lg:gap-20">
          {/* Contact Form */}
          <div className="bg-white p-8 rounded-2xl shadow-xl">
            {submitted ? (
              <div className="text-center p-12">
                <div className="text-accent-base text-6xl mb-6">✓</div>
                <h3 className="text-2xl font-heading text-primary-dark mb-4">
                  Message Received!
                </h3>
                <p className="text-secondary-base">
                  We'll respond soon, Thank you for contacting us.
                </p>
              </div>
            ) : (
              <form onSubmit={handleSubmit} className="space-y-6">
                <div>
                  <label className="block text-sm font-semibold text-primary-dark mb-1">
                    Full Name
                  </label>
                  <input
                    type="text"
                    name="name"  // Name attribute to match template variable
                    className="w-full px-4 py-3 border border-neutral-dark/20 rounded-lg
                      focus:ring-2 focus:ring-accent-base focus:border-transparent"
                    placeholder="John Doe"
                  />
                </div>

                <div>
                  <label className="block text-sm font-semibold text-primary-dark mb-1">
                    Email Address
                  </label>
                  <input
                    type="email"
                    name="email"  // Name attribute to match template variable
                    className="w-full px-4 py-3 border border-neutral-dark/20 rounded-lg
                      focus:ring-2 focus:ring-accent-base focus:border-transparent"
                    placeholder="john@company.com"
                  />
                </div>

                <div>
                  <label className="block text-sm font-semibold text-primary-dark mb-2">
                    Service Needed
                  </label>
                  <select
                    name="service"  // Name attribute to match template variable
                    className="w-full px-4 py-3 border border-neutral-dark/20 rounded-lg
                      focus:ring-2 focus:ring-accent-base focus:border-transparent"
                  >
                    <option value="">Select a service</option>
                    {services.map((service, index) => (
                      <option key={index} value={service}>{service}</option>
                    ))}
                  </select>
                </div>

                <div>
                  <label className="block text-sm font-semibold text-primary-dark mb-1">
                    Project Details
                  </label>
                  <textarea
                    name="message"  // Name attribute to match template variable
                    rows="1"
                    className="w-full px-4 py-3 border border-neutral-dark/20 rounded-lg
                      focus:ring-2 focus:ring-accent-base focus:border-transparent"
                    placeholder="Tell us about your project..."
                  ></textarea>
                </div>

                <button
                  type="submit"
                  className="w-full bg-accent-base text-primary-dark py-4 px-6 rounded-lg
                    font-semibold hover:bg-accent-light transition-colors shadow-md
                    hover:shadow-lg"
                  disabled={loading} // Disable the button while loading
                >
                  {loading ? (
                    <div className="flex justify-center items-center">
                      <svg
                        className="w-6 h-6 text-primary-dark animate-spin"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M12 4v4m0 0v4m0-4h4m-4 0H8"
                        />
                      </svg>
                    </div>
                  ) : (
                    "Send Message"
                  )}
                </button>
              </form>
            )}
          </div>

          {/* Contact Info */}
          <div className="space-y-8">
            <div className="bg-primary-dark text-neutral-light p-8 rounded-2xl shadow-xl">
              <h3 className="text-2xl font-heading mb-6">Visit Us</h3>
              
              <div className="space-y-6">
                <div className="flex items-start gap-4">
                  <MapPinIcon className="h-6 w-6 text-accent-base flex-shrink-0" />
                  <div>
                    <p className="font-semibold">Capital Offset Printing Press</p>
                    <p>L801/1-2, GIDC, Sector 28,</p>
                    <p>Gandhinagar, Gujarat 382028</p>
                  </div>
                </div>

                <div className="flex items-center gap-4">
                  <PhoneIcon className="h-6 w-6 text-accent-base" />
                  <div>
                    <p className="font-semibold">098250 38378</p>
                  
                  </div>
                </div>

                <div className="flex items-center gap-4">
                  <EnvelopeIcon className="h-6 w-6 text-accent-base" />
                  <p className="font-semibold">capitaloffsetgujarat@gmail.com</p>
                </div>
              </div>
            </div>

            {/* Office Hours */}
            {/* <div className="bg-white p-8 rounded-2xl shadow-xl">
              <div className="flex items-center gap-4 mb-6">
                <ClockIcon className="h-8 w-8 text-primary-dark" />
                <h3 className="text-xl font-heading text-primary-dark">
                  Working Hours
                </h3>
              </div>
              <dl className="space-y-4">
                <div className="flex justify-between">
                  <dt className="text-secondary-base">Monday - Saturday</dt>
                  <dd className="font-semibold text-primary-dark">9AM - 8PM</dd>
                </div>
                <div className="flex justify-between">
                  <dt className="text-secondary-base">Sunday</dt>
                  <dd className="font-semibold text-primary-dark">Closed</dd>
                </div>
              </dl>
            </div> */}
            {/* Office Hours */}
<div className="bg-white p-8 rounded-2xl shadow-xl">
  <div className="flex items-center gap-4 mb-6">
    <ClockIcon className="h-8 w-8 text-primary-dark" />
    <h3 className="text-xl font-heading text-primary-dark">
      Working Hours
    </h3>
  </div>
  <dl className="space-y-4">
    <div className="flex justify-between">
      <dt className="text-secondary-base">24/7 Availability</dt>
      <dd className="font-semibold text-primary-dark">Open 24 Hours</dd>
    </div>
  </dl>
</div>

          </div>
        </div>

        {/* Decorative Elements */}
        <div className="absolute top-0 right-0 w-48 h-48 bg-accent-base/10 rounded-full 
          -translate-y-1/2 translate-x-1/2" />
        <div className="absolute bottom-0 left-0 w-32 h-32 bg-primary-dark/10 rounded-full 
          translate-y-1/2 -translate-x-1/2" />
      </div>
    </section>
  )
}

